/**
 * URL generation utilities for KOMBU frontend
 * 
 * Centralizes URL construction logic for API endpoints and public-facing URLs
 * with environment-aware behavior (local vs production).
 * 
 * @see {@link file://./axios.ts} for API client configuration
 */

/**
 * Builds the public order URL for QR codes
 * 
 * Uses current origin (no subdomain/tenant needed as orders are accessed directly by ID)
 * 
 * @param providerOrderId - The order ID from the TPV/POS system
 * @returns Complete URL for accessing the order
 * 
 * @example
 * buildOrderUrl('order-123')
 * // => 'http://localhost:5173/orders/order-123'
 * // or 'https://kombu.es/orders/order-123'
 */
export function buildOrderUrl(providerOrderId: string): string {
    return `${window.location.origin}/orders/${providerOrderId}`;
}
